import { StoreSchema } from "./store/StoreSchema";

export const isLoggedIn = (store: StoreSchema): boolean => {
  return !!store.auth.token && !!store.user;
};
